// extracted by mini-css-extract-plugin
module.exports = {"PlainFeature":"we_a bhj_b"};